import React, {FC} from 'react';
import styled from 'styled-components';

import {useImageLoadingState} from '../../../../common/imageHooks';

/*
 * Props.
 */

interface CommentViewerSingleImageAttachmentPreviewProps {
  src: string;
  alt: string;
  newMultiAttachmentStyle?: boolean;
}

/*
 * Style.
 */

interface CommentViewerPreviewStyleProps {
  $newMultiAttachmentStyle?: boolean;
}
export const StyledCommentViewerPreviewImg = styled.img<CommentViewerPreviewStyleProps>`
  display: block;

  max-height: 226px;
  min-width: 150px;
  max-width: 100%;

  object-fit: contain;
  object-position: center;

  border-radius: ${(p) => (p.$newMultiAttachmentStyle ? '6px' : '15px')};
  background-color: ${(p) => p.theme.greys.shade30};
`;

/*
 * Component.
 */

/**
 * Displays the image and background and border only once it's loaded, otherwise takes up
 * an empty 226px of vertical space.
 */
export const CommentViewerSingleImageAttachmentPreview: FC<CommentViewerSingleImageAttachmentPreviewProps> = (
  props,
) => {
  const {src, alt} = props;
  const {onLoad, imageRef, isLoaded} = useImageLoadingState(src);

  return (
    <StyledCommentViewerPreviewImg
      ref={imageRef}
      $newMultiAttachmentStyle={props.newMultiAttachmentStyle}
      src={src}
      alt={alt}
      onLoad={onLoad}
      style={{opacity: isLoaded ? 1 : 0}}
    />
  );
};
